<template>
  <div>
    <div class="box">
      <!-- <el-steps
        simple
        style="width: 60%; margin: 0 auto; margin-bottom: 5px"
        :active="4"
        v-show="show2"
      >
        <el-step title="选分类和公司">
          <template slot="icon">
            <span>1</span>
          </template>
        </el-step>
        <el-step title="填写资料">
          <template slot="icon">
            <span>2</span>
          </template></el-step
        >
        <el-step title="购买成功">
          <template slot="icon">
            <span>3</span>
          </template>
        </el-step>
        <el-step title="查看保单">
          <template slot="icon">
            <span>4</span>
          </template></el-step
        >
      </el-steps> -->
      <div>
        <div v-show="show1">
          <div class="formBox">
            <div class="formBoxTitle">保险智能推荐器</div>
            <el-form
              class="elformbox"
              ref="searchForm"
              :model="searchForm"
              label-width="70px"
              :rules="rules"
              v-enterToNext="true"
            >
              <el-form-item label="保险种类">
                <el-select
                  v-model="searchForm.typeId"
                  clearable
                  size="mini"
                  placeholder="请选择保险种类"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in myTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="职业等级"
                style="margin-top: 25px"
                prop="jobLevel"
              >
                <el-select
                  v-model="searchForm.jobLevel"
                  clearable
                  size="mini"
                  placeholder="请选择职业等级"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in JobLevelList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="保险额度"
                style="margin-top: 25px"
                prop="sumInsured"
              >
                <el-select
                  v-model="searchForm.sumInsured"
                  placeholder="请选择保险额度"
                  size="mini"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in SumInsuredList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="投保人数"
                prop="peopleNum"
                size="mini"
                style="margin-top: 25px"
              >
                <el-input
                  @keyup.enter.native="handleSearch"
                  v-model="searchForm.peopleNum"
                  clearable
                  pattern="^[1-9]\d*$"
                  @input="checkNum"
                  placeholder="请输入人数"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-form>
            <div style="text-align: center">
              <el-button
                class="btn"
                :loading="fullscreenLoading"
                plain
                @click="InsuranceProductList(1)"
                >智能推荐</el-button
              >
            </div>
            <div class="cooperate">
              <div class="logoTitle">合作伙伴</div>
              <div class="logoList">
                <!-- <img
                src="https://img1.baidu.com/it/u=1415487251,1129038904&fm=253&fmt=auto&app=138&f=JPEG?w=716&h=377"
                alt=""
              /> -->
                <div class="imgBox">
                  <img
                    class="sunImg"
                    src="//img.eqlee.com/upload/4130770925be4daab05241cd7852acc5/2023-09-06/20230906151208091.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="tip">
            <p>
              <span style="color: #ff0000"> 提示:</span>
              1.本系统不直接售卖保险产品，系统内所有保险产品均由我司合作伙伴提供，我司仅提供引流。
            </p>
          </div>
        </div>

        <transition name="el-zoom-in-bottom">
          <div v-show="show2">
            <div class="search">
              <el-row
                :gutter="20"
                style="margin: 0px"
                type="flex"
                align="middle"
              >
                <el-form
                  ref="searchForm2"
                  :model="searchForm"
                  label-width="70px"
                  size="small"
                  :rules="rules"
                  v-enterToNext="true"
                >
                  <el-col :lg="4" :md="6" :sm="12" :xs="24">
                    <el-form-item label="公司">
                      <el-select
                        v-model="searchForm.insuranceCompanyId"
                        clearable
                        placeholder="请选择公司"
                      >
                        <el-option
                          v-for="item in companyList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="4" :md="6" :sm="12" :xs="24">
                    <el-form-item label="保险种类">
                      <el-select
                        v-model="searchForm.typeId"
                        clearable
                        placeholder="请选择保险种类"
                      >
                        <el-option
                          v-for="item in myTypeList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="4" :md="6" :sm="12" :xs="24">
                    <el-form-item label="职业等级">
                      <el-select
                        v-model="searchForm.jobLevel"
                        clearable
                        placeholder="请选择职业等级"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in JobLevelList"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="4" :md="6" :sm="12" :xs="24">
                    <el-form-item label="保险额度">
                      <el-select
                        v-model="searchForm.sumInsured"
                        placeholder="请选择保险额度"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in SumInsuredList"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :lg="4" :md="6" :sm="12" :xs="24">
                    <el-form-item label="投保人数" prop="peopleNum">
                      <el-input
                        @keyup.enter.native="handleSearch"
                        v-model.number="searchForm.peopleNum"
                        clearable
                        @input="checkNum"
                        placeholder="请输入人数"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-button
                    size="small"
                    style="margin-left: 15px"
                    type="primary"
                    plain
                    v-if="verifyPermission('Select')"
                    @click="InsuranceProductList"
                    icon="el-icon-search"
                    >查询</el-button
                  >
                </el-form>
              </el-row>
            </div>

            <div class="insuranceList">
              <div class="Economic">
                <div class="mybox" v-for="item in dataList" :key="item.index">
                  <div class="EconomicList">
                    <div class="container">
                      <div style="padding: 30px 30px 10px 30px">
                        <div class="insuranceCompanyName">
                          {{ item.insuranceCompanyName }}
                        </div>
                        <div class="list-img">
                          <img :src="item.imagePath" alt="" />
                        </div>
                        <div class="introduction">
                          {{ item.name }}
                        </div>
                        <!-- <div class="price">
                          <span class="current-price"
                            >￥{{ item.unitPrice }}/人/{{ item.unit }}</span
                          >
                          <del class="original-price"
                            >￥{{ item.marketUnitPrice }}/人/{{
                              item.unit
                            }}</del
                          >
                        </div> -->
                        <!-- <div class="price">
                          总金额：
                          <span class="current-price" style="font-size: 20px"
                            >￥{{ item.price * searchForm.peopleNum }}</span
                          >
                        </div> -->
                        <div
                          style="
                            font-size: 11px;
                            margin-top: 6px;
                            color: #9b9b9b;
                          "
                        >
                          报价仅供参考，实际以【具体的保险公司或经纪公司】所提供数据为准
                        </div>
                      </div>
                      <el-button
                        class="container-btn"
                        size="mini"
                        @click="navBuy(item)"
                        >前往购买</el-button
                      >
                    </div>
                  </div>
                </div>
                <el-empty
                  style="margin: 0 auto"
                  v-if="dataList.length == 0"
                  description="暂无数据"
                ></el-empty>
              </div>
              <div style="margin-top: 90px; text-align: center">
                <el-button size="mini" pain v-if="moreBtn" @click="more"
                  >查看更多</el-button
                >
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyPermissionMinix } from "@/utils/mixin";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  mixins: [verifyPermissionMinix],
  components: {
    Treeselect,
  },
  data() {
    let validatePeopleNum = (rule, value, callback) => {
      console.log(value);
      if (!value) {
        console.log(2);
        callback(new Error("请输入投保人数，并且不少于5人"));
      }
      if (value < 5) {
        callback(new Error("投保人数不少于5人"));
      } else {
        callback();
      }
    };
    return {
      fullscreenLoading: false,
      searchForm: { peopleNum: 5 },
      data: [{ index: 1 }],
      categoryList: [],
      dataList: [],
      show1: true,
      show2: false,
      moreBtn: false,
      JobLevelList: [],
      allList: [],
      myTypeList: [],
      companyList: [],
      SumInsuredList: [],
      rules: {
        peopleNum: [{ validator: validatePeopleNum, trigger: "blur" }],
      },
    };
  },
  mounted() {
    // this.InsuranceWorkCategoryList();
    if (this.$route.query.flag == 1) {
      this.show1 = !this.show1;
      this.show2 = !this.show2;
    }
    this.ProductSumInsuredList();
    this.TypeList();
    this.getCompanyList();
  },
  methods: {
    checkNum() {
      this.searchForm.peopleNum = this.searchForm.peopleNum.replace(
        /[^\d]/g,
        ""
      );
    },
    feiSelect() {},
    ProductSumInsuredList() {
      this.$api.Insurance.ProductSumInsuredList().then((res) => {
        if (res.error === false) {
          this.SumInsuredList = res.data;
          this.$set(this.searchForm, "sumInsured", res.data[0]);

          this.ProductGetJobLevelList();

          console.log(res);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    ProductGetJobLevelList() {
      this.$api.Insurance.ProductGetJobLevelList().then((res) => {
        if (res.error === false) {
          this.JobLevelList = res.data;
          this.InsuranceProductList();

          console.log(res);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    more() {
      this.moreBtn = false;
      this.dataList = this.allList;
    },
    getCompanyList() {
      this.$api.Insurance.CompanyList().then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
          console.log(res);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    TypeList() {
      this.$api.Insurance.TypeList().then((res) => {
        if (res.error === false) {
          this.myTypeList = res.data;
          console.log(res);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    InsuranceProductList(flag) {
      this.$refs["searchForm"].validate((valid) => {
        if (!valid) {
          this.$message.warning("填写信息有误，请检查表单");
          return;
        }
        let sendData = {
          insuranceCompanyId: this.searchForm.insuranceCompanyId,
          categoryId: this.searchForm.categoryId,
          typeId: this.searchForm.typeId,
          peopleNum: this.searchForm.peopleNum,
          jobLevel: this.searchForm.jobLevel,
          sumInsured: this.searchForm.sumInsured,
        };

        this.fullscreenLoading = true;
        this.$api.Insurance.InsuranceProductList(sendData).then((res) => {
          console.log(res);
          if (res.error === false) {
            if (this.dataList.length > 5) {
              this.dataList = res.data.slice(0, 4);
              this.moreBtn = true;
            } else {
              this.dataList = res.data;
            }
            this.allList = res.data;
            this.fullscreenLoading = false;

            if (flag == 1) {
              this.show1 = !this.show1;
              this.show2 = !this.show2;
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    navBuy(item) {
      if (this.$store.state.authenticationState != 2) {
        this.$confirm("暂未企业认证,请前往认证!", "提示", {
          confirmButtonText: "前往认证",
          cancelButtonText: "关 闭",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/certifiSelection");
          })
          .catch(() => {});
        return;
      }
      console.log(item);
      window.localStorage.setItem("detail", JSON.stringify(item));

      // this.$router.push({
      //   path: "/insuranceIntroduction",
      //   // query: { myObj: encodedObj },
      // });
      this.$router.push({
        path: "/insuranceDescriptionPage",
        // query: { myObj: encodedObj },
      });
    },
    InsuranceWorkCategoryList() {
      this.$api.Insurance.InsuranceWorkCategoryList().then((res) => {
        if (res.error === false) {
          res.data.forEach((element) => {
            if (element.parentId == null) {
              this.categoryList.push(element);
            }
          });
          // this.categoryList = res.data;
          // console.log(res);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 74vh;
  // padding: 0px 63px 0px 63px;
  overflow: hidden;
  .search {
    margin-top: 10px;
    height: 70px;
    display: flex;
    align-items: center;
    background-color: #feffff;
    box-shadow: 1px 6px 13px 0px #d0d0d0;
    border-radius: 25px;
  }
  .logoList {
    display: flex;
    justify-content: center;
    margin-left: 20px;
    margin-bottom: 39px;
    .imgBox {
      border: solid 1px #e1e1e1;

      padding: 0 19px;
      .sunImg {
        width: 70px;
        // height: 70px;
        border-radius: 5px;
      }
    }
  }
  .tip {
    text-align: center;
    p {
      margin-top: 23px;
    }
  }
  .formBox {
    margin: 0 auto;
    width: 800px;
    background-color: #fff;
    box-shadow: 1px 6px 13px 0px #d0d0d0;
    border-radius: 25px;
    margin-top: 63px;
    .cooperate {
      display: flex;
      padding: 0 40px;
      .logoTitle {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        writing-mode: vertical-rl;
        width: 29px;
        font-size: 14px;
        height: 65px;
        border-right: 1px solid #999999;
      }
    }
    .elformbox {
      padding: 60px 210px 12px 210px;
    }
    .btn {
      width: 150px;
      height: 34px;
      line-height: 10px;
      background-color: #4380fb;
      border-radius: 10px;
      color: white;
      margin-bottom: 57px;
    }

    .formBoxTitle {
      background-color: #e8f5ff;
      height: 60px;
      line-height: 60px;
      padding-left: 64px;
      font-size: 22px;
      color: #4369f1;
      .title {
        width: 140px;
        position: absolute;
        top: -32px;
        color: #4369f1;
        font-size: 20px;
        right: calc(50% - 70px);
      }
    }
  }
  .insuranceList {
    padding-top: 10px;
    border-top: 1px solid #ccc;
    height: 65vh;
    overflow: auto;
    // padding: 0 150px;
    .Economic {
      width: 100%;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      .mybox {
        width: 340px;
        cursor: pointer;
        margin: 0 12px;
      }
      // .mybox:nth-child(5n + 1) {
      //   margin-left: 0;
      //   padding-bottom: 10px;
      // }
      .title {
        font-weight: 700;
        font-size: 20px;
      }
      .EconomicList {
        width: 100%;
        margin-top: 15px;
        .container {
          border: 1px solid rgba(204, 204, 204, 0.5);
          // padding: 30px;
          background-color: #feffff;
          box-shadow: 1px 6px 13px 0px #d0d0d0;
          border-radius: 25px;
          position: relative;
          .insuranceCompanyName {
            position: absolute;
            top: 0;
            left: 0;
            // width: 130px;
            padding: 0 15px;
            height: 32px;
            background-color: #e8f5ff;
            border-radius: 25px 0px 20px 0px;
            text-align: center;
            line-height: 32px;
          }
          .list-img {
            box-sizing: border-box;
            width: 100%;
            padding-bottom: 15px;
            img {
              width: 100%;
              border-radius: 5px;
            }
          }
          .container-btn {
            width: 100%;
            height: 36px;
            background-color: #4380fb;
            border-radius: 0px 0px 25px 25px;
            color: #fff;
          }
          .introduction {
            text-align: left;
            font-weight: 700;
            font-size: 16px;
          }
          .price {
            flex: 1;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            margin-top: 6px;
            .current-price {
              // margin-left: 4px;
              vertical-align: baseline;
              text-align: left;
              line-height: 25px;
              font-family: PingFangSC-Medium;
              font-size: 14px;
              color: #ff6600;
            }
            .original-price {
              margin-left: 8px;
              vertical-align: baseline;
              text-decoration: line-through;
              line-height: 20px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #9b9b9b;
            }
          }
        }
      }
    }
    ::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 6px;
    }

    ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      //background-color: #8c8c8c;
      background-color: rgba(0, 0, 0, 0.25);
    }

    ::-webkit-scrollbar-track {
      background-color: #f6f6f6;
    }
    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-track {
      border: 0;
    }
  }
  .Economic:first-child {
    margin-top: 0;
  }
}
</style>